import React, { ReactNode } from "react";
import "./FeatureLockedModal.scss";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import Modal, {
  ModalText,
  ModalTitle,
  OutsideClickModes,
} from "src/app/components/Modal/Modal";
import securityImage from "src/images/security.png";

interface Props {
  onClose: () => void;
  text?: ReactNode | string;
}

function FeatureLockedModal(props: Props) {
  const { onClose, text } = props;

  return (
    <Modal
      className="feature-locked-modal"
      onClose={onClose}
      displayCancelButton
      closeButtonText={
        <IDHFormattedMessage id="ws_close" defaultMessage="Close" />
      }
      closeButtonVariant="white-with-light-grey-border"
      outsideClick={OutsideClickModes.Allow}
    >
      <div className="feature-locked-modal__text">
        <ModalTitle>
          <IDHFormattedMessage id="ws_oops" defaultMessage="Oops..." />
        </ModalTitle>

        <ModalText>
          {text || (
            <IDHFormattedMessage
              id="ws_feature_is_not_available"
              defaultMessage="Feature is not available."
            />
          )}
        </ModalText>
      </div>

      <img className="feature-locked-modal__image" alt="" src={securityImage} />
    </Modal>
  );
}

export default FeatureLockedModal;
